/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import Header from "./Comman/Header";
import Sidebar from "./Comman/Sidebar";
import { OnmaxContext } from "../OnmaxContext";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import Timer from "../Commponents/Timer";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./Dashboard.css";
import {
  LuArrowUpRight,
  LuBriefcase,
  LuCalendar,
  LuClock,
  LuGitMerge,
  LuLock,
  LuMedal,
  LuNetwork,
  LuTrendingUp,
  LuTrophy,
  LuUserCheck,
  LuUserPlus,
  LuUsers,
  LuWallet,
  LuZap,
} from "react-icons/lu";

const getBankTourKey = (user) => (user ? `bank_details_tour_seen_${user}` : null);

export default function Dashboard() {
  const { copyaddress, formatAddress, toastError, toastSuccess } = useContext(OnmaxContext);
  const [data, setdata] = useState([]);
  const [showMobileInput, setShowMobileInput] = useState(false);
  const [profile, setprofile] = useState([]);
  const [contact, setcontact] = useState(null);
  // const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  // const [otpVerified, setOtpVerified] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const username = localStorage.getItem("username");
  const location = useLocation();

  const sendOtpHandler = () => {
    let mobile = contact;

    // Remove India country code (91)
    if (mobile.startsWith("91")) {
      mobile = mobile.slice(2);
    }

    sendOtp(mobile);
  };

  const getprofileData = async () => {
    if (!username) return;
    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "profile",
        username,
        key: process.env.REACT_APP_KEY,
      });
      if (res.data?.error || !res.data?.data) {
        setprofile(null);
      } else {
        setprofile(res.data.data);
      }
    } catch (error) {
      console.error("Profile fetch error:", error);
      setprofile(null);
    }
  };

  const [showAnnouncement, setShowAnnouncement] = useState(true);
  const [bankForm, setBankForm] = useState({
    account_name: "",
    account_number: "",
    bank_name: "",
    ifsc_code: "",
  });
  const [bankLoading, setBankLoading] = useState(false);
  const bankDetailsFilled = profile?.filled_bank_details === true;
  const bankCardRef = useRef(null);
  const [showBankTour, setShowBankTour] = useState(false);
  const [tourRect, setTourRect] = useState(null);

  const closeAnnouncement = () => {
    setShowAnnouncement(false);
  };

  const updateBankTourRect = () => {
    const el = bankCardRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const pad = 8;
    setTourRect({
      top: Math.max(12, rect.top - pad),
      left: Math.max(12, rect.left - pad),
      width: Math.min(rect.width + pad * 2, window.innerWidth - 24),
      height: rect.height + pad * 2,
    });
  };

  const completeBankTour = () => {
    const tourKey = getBankTourKey(username);
    // console.log('tourKey', tourKey);

    if (tourKey) localStorage.setItem(tourKey, "1");
    setShowBankTour(false);
    setTourRect(null);
  };

  const handleBankChange = (e) => {
    const { name, value } = e.target;
    let next = value;
    if (name === "ifsc_code") next = value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 11);
    if (name === "account_number") next = value.replace(/[^0-9]/g, "").slice(0, 18);
    if (name === "account_name") next = value.replace(/[^a-zA-Z\s.]/g, "").slice(0, 60);
    if (name === "bank_name") next = value.slice(0, 80);
    setBankForm((prev) => ({ ...prev, [name]: next }));
  };

  const handleLogoutExpired = async () => {
    toastError("Login Expired!");
    try {
      await axios.post(
        process.env.REACT_APP_BACKEND_LINK,
        {
          method: "user",
          submethod: "logoutu",
          username,
          key: process.env.REACT_APP_KEY,
        },
        { withCredentials: true }
      );
    } catch (error) {
      console.error("Logout failed:", error);
    }
    const preserved = {};
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.includes("_tour_seen_")) {
        preserved[key] = localStorage.getItem(key);
      }
    }
    localStorage.clear();
    Object.entries(preserved).forEach(([key, value]) => {
      if (value != null) localStorage.setItem(key, value);
    });
    window.location.replace("/");
  };

  const insertBankDetails = async (e) => {
    e.preventDefault();
    const { account_name, account_number, bank_name, ifsc_code } = bankForm;

    if (!account_name || !account_number || !bank_name || !ifsc_code) {
      toastError("All Bank Details Are Required.");
      return;
    }
    // if (account_number.length < 9) {
    //   toastError("Enter a valid account number.");
    //   return;
    // }
    // if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc_code)) {
    //   toastError("Enter a valid IFSC code.");
    //   return;
    // }

    try {
      setBankLoading(true);
      const res = await axios.post(
        process.env.REACT_APP_BACKEND_LINK,
        {
          method: "user",
          submethod: "insertbank",
          key: process.env.REACT_APP_KEY,
          username,
          account_name: account_name.trim(),
          account_number,
          bank_name: bank_name.trim(),
          ifsc_code,
        },
        { withCredentials: true }
      );

      if (res.data?.resCode === 401) {
        await handleLogoutExpired();
        return;
      }

      if (res.data?.resCode === 200) {
        toastSuccess(res.data?.msg || "Save Successfully");
        setBankForm({
          account_name: "",
          account_number: "",
          bank_name: "",
          ifsc_code: "",
        });
        setprofile((prev) => (prev ? { ...prev, filled_bank_details: true } : prev));
        getprofileData();
        return;
      }

      toastError(res.data?.error || res.data?.message || "Failed to save bank details");
      if (res.data?.error?.toLowerCase?.().includes("already exist")) {
        setprofile((prev) => (prev ? { ...prev, filled_bank_details: true } : prev));
        getprofileData();
      }
    } catch (error) {
      console.error("insertBankDetails error:", error);
      toastError("Network or server error!");
    } finally {
      setBankLoading(false);
    }
  };

  useEffect(() => {
    if (location.pathname === "/dashboard") {
      setShowAnnouncement(true);
    }
    getprofileData();
    getData();
  }, [username, location.pathname]);

  useEffect(() => {
    if (!showAnnouncement) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [showAnnouncement]);

  // First-time feature tour for Add Your Bank Details (once per user)
  useEffect(() => { 
    if (showAnnouncement || !username) return undefined;

    const tourKey = getBankTourKey(username);
    // console.log('tourKey', tourKey);

    if (!tourKey || localStorage.getItem(tourKey) === "1") return undefined;

    let showTimer;
    const startTimer = setTimeout(() => {
      const el = bankCardRef.current;
      if (!el) return;
      el.scrollIntoView({ behavior: "smooth", block: "center" });

      showTimer = setTimeout(() => {
        updateBankTourRect();
        setShowBankTour(true);
      }, 450);
    }, 500);

    return () => {
      clearTimeout(startTimer);
      if (showTimer) clearTimeout(showTimer);
    };
  }, [showAnnouncement, username]);

  useEffect(() => {
    if (!showBankTour) return undefined;

    updateBankTourRect();
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const sync = () => updateBankTourRect();
    window.addEventListener("resize", sync);
    window.addEventListener("scroll", sync, true);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("resize", sync);
      window.removeEventListener("scroll", sync, true);
    };
  }, [showBankTour]);

  const getData = async () => {
    if (!username) return;
    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "getbyid",
        username: username,
        key: process.env.REACT_APP_KEY,
      })
      .then((res) => {
        if (res.data.error) return "";
        setdata(res.data.data);
      });
  };

  const sendOtp = async (contact) => {
    try {
      setLoadingOtp(true);
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "sendcontct",
        key: process.env.REACT_APP_KEY,
        mobile: contact,
        username: profile?.username,
        password: profile?.password,
      });
      if (res.data?.resCode === 200) {
        toastSuccess(res.data?.message || "OTP sent to your Contact No");
      } else {
        toastError(res.data?.message || "Failed To Send OTP");
        return;
      }
      setShowOtp(true);
    } catch {
      toastError("Failed to send OTP");
    } finally {
      setLoadingOtp(false);
    }
  };

  // const verifyOTP = async () => {
  //   if (otp.length !== 6) { toastError("Enter valid 6-digit OTP"); return; }
  //   try {
  //     const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
  //       method: "user", submethod: "verifymobile", key: process.env.REACT_APP_KEY, mobile: contact, otp: otp,
  //     });
  //     if (res.data?.resCode === 200) { toastSuccess(res.data?.message || "OTP verified"); setOtpVerified(true); setShowOtp(false); setOtp(""); getprofileData(); }
  //     else { toastError(res.data?.message || "Invalid OTP"); }
  //   } catch { toastError("OTP verification failed"); }
  // };


  const Tile = ({ icon, label, value, neonClass }) => (
    <div className="db-tile">
      <div className={`db-tile-icon-new ${neonClass}`}>{icon}</div>
      <div className="db-tile-text">
        <h4>{value}</h4>
        <p>{label}</p>
      </div>
    </div>
  );

  const announcementModal = showAnnouncement
    ? createPortal(
      <div className="db-announcement-overlay" onClick={closeAnnouncement}>
        <div
          className="db-announcement-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="dashboard-announcement-title"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            className="db-announcement-close"
            onClick={closeAnnouncement}
            aria-label="Close announcement"
          >
            <i className="fa fa-times"></i>
          </button>

          <div className="db-announcement-header">
            <div className="db-announcement-icon">
              <i className="fa fa-bullhorn"></i>
            </div>
            <h2 id="dashboard-announcement-title">Important Announcement – Getlink Community</h2>
            <p>Payment Release Update</p>
          </div>

          <div className="db-announcement-body">
            <div className="db-announcement-section">
              <p className="db-announcement-lead">Dear Getlink Community, 🙏</p>
              <p>
                Something important is happening within the Getlink. We kindly request everyone to remain patient, positive, and supportive during this time. ❤️
              </p>
            </div>

            <div className="db-announcement-section db-announcement-section-date">
              <p>
                Please note that from today, <strong>bank details can no longer be added or updated.</strong> We sincerely request everyone to keep this in mind and avoid any confusion regarding bank details.
              </p>
              <p>
                As we have promised, Getlink is working toward releasing payments to the registered bank accounts till <strong>20th November 2026.</strong> We understand that everyone is eagerly waiting for their payments, and we truly appreciate your patience and continued trust.
              </p>
            </div>

            <div className="db-announcement-section db-announcement-section-success">
              <p>
                We kindly request the entire community to remain calm, stay united, and wait for further official updates. We hope to bring positive news to everyone very soon. 🙏
              </p>
            </div>

            <p className="db-announcement-signature">
              Stay United • Stay Positive • Keep Faith! 🤝❤️
              <br />
              — Getlink Community Team
            </p>
          </div>
        </div>
      </div>,
      document.body
    )
    : null;

  const bankTourPlacement = (() => {
    if (!tourRect) return { style: null, placeBelow: true };
    const tooltipWidth = Math.min(340, window.innerWidth - 32);
    const spaceBelow = window.innerHeight - (tourRect.top + tourRect.height);
    const placeBelow = spaceBelow > 180;
    const left = Math.min(
      Math.max(16, tourRect.left + tourRect.width / 2 - tooltipWidth / 2),
      window.innerWidth - tooltipWidth - 16
    );
    const top = placeBelow
      ? tourRect.top + tourRect.height + 14
      : Math.max(16, tourRect.top - 14);

    return {
      placeBelow,
      style: {
        width: tooltipWidth,
        left,
        top,
      },
    };
  })();

  const bankTourModal =
    showBankTour && tourRect
      ? createPortal(
        <div className="db-tour-root" role="dialog" aria-modal="true" aria-labelledby="bank-tour-title">
          <div className="db-tour-backdrop" onClick={completeBankTour} />
          <div
            className="db-tour-spotlight"
            style={{
              top: tourRect.top,
              left: tourRect.left,
              width: tourRect.width,
              height: tourRect.height,
            }}
          />
          <div
            className={`db-tour-tooltip ${bankTourPlacement.placeBelow ? "is-below" : "is-above"}`}
            style={bankTourPlacement.style}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="db-tour-badge">New Feature</div>
            <h3 id="bank-tour-title">Add Your Bank Details</h3>
            <p>
              You can now submit your bank account information here for withdrawals and payouts.
              Fill the form once — it only needs to be added one time.
            </p>
            <div className="db-tour-actions">
              <button type="button" className="db-tour-btn secondary" onClick={completeBankTour}>
                Skip
              </button>
              <button type="button" className="db-tour-btn" onClick={completeBankTour}>
                Got it
              </button>
            </div>
          </div>
        </div>,
        document.body
      )
      : null;

  return (
    <>
      {announcementModal}
      {bankTourModal}

      <div className="body-bg">
        <Sidebar />
        <Header />
        {/* {showMaintenance && (
          <div className="sticky-top w-100 bg-danger text-white text-center py-2 fw-bold shadow">
            ⚠ System Maintenance: We are currently experiencing technical issues.
          </div>
        )} */}
        <section className="nftmax-adashboard nftmax-show">
          <div className="db-scene py-3" style={{ borderRadius: "29px" }}>
            <div className="container">
              {/* ━━━ ENHANCED 3D PROFILE CARD ━━━ */}
              <div className="db-profile-card-wrap py-3">
                <div className="db-profile-card">
                  <div className="db-card-border-anim"></div>

                  <div className="db-profile-content">
                    <div className="db-profile-header">
                      <div className="db-avatar-3d">
                        <i className="fa fa-user-shield"></i>
                      </div>
                      <div className="db-user-main">
                        <p>{profile?.rank || "NO RANK"}</p>
                        <h2>{profile?.fromname || "User Name"}</h2>
                      </div>
                      <div className="db-profile-balance">
                        <div className="db-rank-lbl">Current Balance</div>
                        <div className="db-rank-val">
                          ${profile?.balance?.toFixed(2) || "0.00"}
                        </div>
                      </div>
                    </div>

                    <div className="db-profile-details">
                      <div className="db-profile-info-pill">
                        <span className="db-pill-lbl">Username</span>
                        <div className="db-pill-val">
                          <span>{username || "-"}</span>
                          <i className="fa fa-copy db-pill-copy" onClick={() => copyaddress(username)}></i>
                        </div>
                      </div>
                      <div className="db-profile-info-pill">
                        <span className="db-pill-lbl">Email Address</span>
                        <div className="db-pill-val">
                          <span style={{ maxWidth: "180px", overflow: "hidden", textOverflow: "ellipsis" }}>{profile?.email || "-"}</span>
                          <i className="fa fa-copy db-pill-copy" onClick={() => copyaddress(profile?.email)}></i>
                        </div>
                      </div>
                      <div className="db-profile-info-pill">
                        <span className="db-pill-lbl">Contact No</span>
                        <div className="db-pill-val">
                          <span>{profile?.contactno ? `+${profile?.contactno}` : "-"}</span>
                        </div>
                      </div>
                      <div className="db-profile-info-pill">
                        <span className="db-pill-lbl">Wallet Address</span>
                        <div className="db-pill-val">
                          <span>{profile?.address ? formatAddress(profile?.address) : "-"}</span>
                          <i className="fa fa-copy db-pill-copy" onClick={() => copyaddress(profile?.address)}></i>
                        </div>
                      </div>
                      <div className="db-profile-info-pill">
                        <span className="db-pill-lbl">Referral ID</span>
                        <div className="db-pill-val">
                          <span>{profile?.ref_address ? formatAddress(profile?.ref_address) : "-"}</span>
                          <i className="fa fa-copy db-pill-copy" onClick={() => copyaddress(profile?.ref_address)}></i>
                        </div>
                      </div>
                      <div
                        className="db-profile-info-pill"
                        style={{ background: "linear-gradient(135deg, rgba(0, 111, 227, 0.1), rgba(139, 92, 246, 0.1))" }}
                      >
                        <span className="db-pill-lbl">Status</span>
                        <div className="db-pill-val">
                          <span style={{ color: "#22c55e" }}>
                            <i className="fa fa-check-circle me-1"></i> Verified
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ━━━ ADD YOUR BANK DETAILS ━━━ */}
              <div
                ref={bankCardRef}
                className={`db-profile-card mb-5 db-bank-card${showBankTour ? " db-tour-target" : ""}`}
                id="bank-details-card"
              >
                <div className="db-sec-hdr">
                  <div className="db-sec-dot"></div>
                  <div className="db-sec-title">Add Your Bank Details</div>
                </div>
                <p className="db-bank-subtitle">
                  {bankDetailsFilled
                    ? "Your bank account information is already registered."
                    : "Submit your bank account information for withdrawals and payouts."}
                </p>

                {bankDetailsFilled ? (
                  <div className="db-bank-success">
                    <div className="db-bank-success-icon">
                      <i className="fa fa-check-circle"></i>
                    </div>
                    <div>
                      <h4>Already filled up your bank details</h4>
                      <p>You have already submitted your bank account information. No further action is needed.</p>
                    </div>
                  </div>
                ) : (
                  <form className="db-bank-form" onSubmit={insertBankDetails} noValidate>
                    <div className="db-bank-grid">
                      <div className="db-bank-field">
                        <label className="db-bank-label" htmlFor="account_name">
                          Account Holder Name
                        </label>
                        <div className="db-bank-input-wrap">
                          <i className="fa fa-user"></i>
                          <input
                            id="account_name"
                            name="account_name"
                            type="text"
                            className="db-bank-input"
                            placeholder="Enter account holder name"
                            value={bankForm.account_name}
                            onChange={handleBankChange}
                            autoComplete="name"
                            required
                          />
                        </div>
                      </div>

                      <div className="db-bank-field">
                        <label className="db-bank-label" htmlFor="account_number">
                          Account Number
                        </label>
                        <div className="db-bank-input-wrap">
                          <i className="fa fa-hashtag"></i>
                          <input
                            id="account_number"
                            name="account_number"
                            type="text"
                            inputMode="numeric"
                            className="db-bank-input"
                            placeholder="Enter account number"
                            value={bankForm.account_number}
                            onChange={handleBankChange}
                            autoComplete="off"
                            required
                          />
                        </div>
                      </div>

                      <div className="db-bank-field">
                        <label className="db-bank-label" htmlFor="bank_name">
                          Bank Name
                        </label>
                        <div className="db-bank-input-wrap">
                          <i className="fa fa-university"></i>
                          <input
                            id="bank_name"
                            name="bank_name"
                            type="text"
                            className="db-bank-input"
                            placeholder="Enter bank name"
                            value={bankForm.bank_name}
                            onChange={handleBankChange}
                            autoComplete="organization"
                            required
                          />
                        </div>
                      </div>

                      <div className="db-bank-field">
                        <label className="db-bank-label" htmlFor="ifsc_code">
                          IFSC Code
                        </label>
                        <div className="db-bank-input-wrap">
                          <i className="fa fa-code"></i>
                          <input
                            id="ifsc_code"
                            name="ifsc_code"
                            type="text"
                            className="db-bank-input"
                            placeholder="e.g. SBIN0001234"
                            value={bankForm.ifsc_code}
                            onChange={handleBankChange}
                            autoComplete="off"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="db-bank-submit"
                      disabled={bankLoading}
                    >
                      {bankLoading ? (
                        <>
                          <i className="fa fa-spinner fa-spin"></i> Saving...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-save"></i> Save Bank Details
                        </>
                      )}
                    </button>
                  </form>
                )}
              </div>
              {/* ━━━ UPGRADED PRIME REWARD AREA ━━━ */}
              <div className="db-profile-card mb-5">
                {/* Top 5 Horizontal Action Buttons */}
                <Link to="/stake" className="db-widget-bar text-decoration-none">
                  <div className="db-widget-icon-box" style={{ background: "#e0f2fe", color: "#0ea5e9" }}>
                    <i className="fa fa-plus-circle"></i>
                  </div>
                  <div className="db-widget-label">Purchase Now</div>
                  <div className="db-widget-badge" style={{ background: "#0ea5e9" }}>
                    <i className="fa fa-chevron-right"></i>
                  </div>
                </Link>

                <Link to="/wtihdrawal" className="db-widget-bar text-decoration-none">
                  <div className="db-widget-icon-box" style={{ background: "#f3e8ff", color: "#a855f7" }}>
                    <i className="fa fa-arrow-up"></i>
                  </div>
                  <div className="db-widget-label">Withdrawal</div>
                  <div className="db-widget-badge" style={{ background: "#a855f7" }}>
                    <i className="fa fa-chevron-right"></i>
                  </div>
                </Link>

                <Link to="/transfer" className="db-widget-bar text-decoration-none">
                  <div className="db-widget-icon-box" style={{ background: "#ffedd5", color: "#f97316" }}>
                    <i className="fa fa-exchange-alt"></i>
                  </div>
                  <div className="db-widget-label">Transfer</div>
                  <div className="db-widget-badge" style={{ background: "#f97316" }}>
                    <i className="fa fa-chevron-right"></i>
                  </div>
                </Link>

                <Link to="/ecosystem-wallet-transfer" className="db-widget-bar text-decoration-none">
                  <div className="db-widget-icon-box" style={{ background: "#ffedd5", color: "#f97316" }}>
                    <i className="fa fa-wallet"></i>
                  </div>
                  <div className="db-widget-label">Ecosystem Wallet Transfer</div>
                  <div className="db-widget-badge" style={{ background: "#f97316" }}>
                    <i className="fa fa-chevron-right"></i>
                  </div>
                </Link>

                <div
                  className="db-widget-bar"
                  style={{ cursor: "pointer" }}
                  onClick={() => copyaddress(`${window.location.origin}/register?ref=${username}`)}
                >
                  <div className="db-widget-icon-box" style={{ background: "#fce7f3", color: "#ec4899" }}>
                    <i className="fa fa-link"></i>
                  </div>
                  <div className="db-widget-label">Copy Sponsor Link</div>
                  <div className="db-widget-badge" style={{ background: "#ec4899" }}>
                    <i className="fa fa-copy"></i>
                  </div>
                </div>

                <Link to="/deposit" className="db-widget-bar text-decoration-none">
                  <div className="db-widget-icon-box" style={{ background: "#dcfce7", color: "#22c55e" }}>
                    <i className="fa fa-wallet"></i>
                  </div>
                  <div className="db-widget-label">Deposit</div>
                  <div className="db-widget-badge" style={{ background: "#22c55e" }}>
                    <i className="fa fa-chevron-right"></i>
                  </div>
                </Link>

                {/* Bottom 2 Vertical Grid Boxes */}
                <div className="db-widget-grid">
                  {/* Box 1: Prime Reward & OTP Verification */}
                  <div className="db-profile-info-pill">
                    <div className="db-prime-title mb-3" style={{ fontSize: "18px" }}>
                      <span></span> Prime Reward
                    </div>
                    <div className="db-prime-timer mb-4">
                      <div className="db-prime-timer-lbl">Time Remaining</div>
                      {data?.primeEnd === "No Time" ? (
                        <div style={{ fontSize: "26px", fontWeight: "800", color: "#22c55e" }}>No Time! 🎉</div>
                      ) : (
                        <div style={{ transform: "scale(1.1)" }}>
                          <Timer targetDate={data?.primeEnd} />
                        </div>
                      )}
                    </div>

                    {/* OTP LOGIC INTEGRATED */}
                    {/* {showOtp && (
                      <div className="db-otp-box mt-4 p-4" style={{ background: '#f8fafc', borderRadius: '24px', border: '1px solid #e2e8f0', boxShadow: 'inset 0 0 15px rgba(0,0,0,0.02)' }}>
                        <div className="text-center mb-4">
                          <h5 className="mb-1" style={{ color: '#1e293b', fontWeight: '800' }}>Verify OTP</h5>
                          <p style={{ color: '#64748b', fontSize: '12px' }}>Enter the 6-digit code sent to your phone</p>
                        </div>
                        <input type="text" maxLength={6} value={otp}
                          onChange={(e) => { if (/^[0-9]*$/.test(e.target.value)) setOtp(e.target.value); }}
                          placeholder="• • • • • •" className="db-otp-input effective-otp-input mb-3"
                          style={{ fontSize: '24px', letterSpacing: '8px', height: '56px' }}
                        />
                        <button className="db-btn effective-btn-blue w-100" onClick={verifyOTP} disabled={otp.length !== 6}>Verify OTP</button>
                      </div>
                    )} */}
                  </div>

                  {/* Box 2: Mobile Number & Account Status */}
                  <div className="db-profile-info-pill">
                    <div className="db-prime-title mb-3" style={{ fontSize: "18px" }}>
                      <span></span> Secure Account
                    </div>
                    {profile?.contactno && (
                      <h4 className="fw-bold mb-0" style={{ fontSize: "15px", color: "#1e293b" }}>
                        Already Verified Mobile Number
                      </h4>
                    )}
                    {!profile?.contactno && !showMobileInput && (
                      <div className="db-mobile-section mt-4">
                        <div className="d-flex align-items-center mb-4">
                          <div
                            className="icon-blue"
                            style={{
                              width: 44,
                              height: 44,
                              borderRadius: "12px",
                              background: "white",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: 15,
                              boxShadow: "0 0 15px rgba(59, 130, 246, 0.3)",
                              color: "#3b82f6",
                              fontSize: "20px",
                            }}
                          >
                            <LuUserPlus />
                          </div>
                          <h4 className="fw-bold mb-0" style={{ fontSize: "15px", color: "#1e293b" }}>
                            Link Mobile Number
                          </h4>
                        </div>
                        <div className="effective-phone-input mb-3">
                          <PhoneInput
                            country={"in"}
                            value={contact}
                            onChange={(value) => setcontact(value)}
                            placeholder="Enter mobile number"
                            buttonStyle={{ display: "none" }}
                            inputStyle={{ paddingLeft: "20px", fontSize: "16px" }}
                          />
                        </div>
                        <button className="db-btn effective-btn-gold w-100" onClick={sendOtpHandler}>
                          {loadingOtp ? "Sending OTP..." : "Update"}
                        </button>
                      </div>
                    )}

                    {/* <div className="db-widget-list mt-3">
                      <div className="db-widget-list-item" onClick={() => copyaddress(username)}>
                        <div className="db-widget-list-icon" style={{ background: '#fee2e2', color: '#ef4444' }}>
                          <i className="fa fa-user"></i>
                        </div>
                        <div className="db-widget-list-text">{username || "Profile"}</div>
                        <div className="db-widget-list-arr"><i className="fa fa-copy"></i></div>
                      </div>
                      <div className="db-widget-list-item">
                        <div className="db-widget-list-icon" style={{ background: '#dcfce7', color: '#22c55e' }}>
                          <i className="fa fa-shield-alt"></i>
                        </div>
                        <div className="db-widget-list-text">Account Status</div>
                        <div className="db-widget-list-arr" style={{ background: '#dcfce7', color: '#22c55e' }}><i className="fa fa-check"></i></div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>

              {/* ━━━ REWARDS OVERVIEW ━━━ */}
              <div className="db-profile-card mb-5">
                <div className="db-sec-hdr">
                  <div className="db-sec-dot"></div>
                  <div className="db-sec-title">Rewards Overview</div>
                </div>
                <div className="db-grid">
                  <Tile
                    neonClass="icon-yellow"
                    icon={<LuCalendar />}
                    label="Weekly Reward"
                    value={`$${profile?.week_rew ? parseFloat(profile.week_rew).toFixed(2) : "0.00"}`}
                  />
                  {/*<Tile neonClass="icon-blue" icon={<LuUserPlus />} label="Direct Reward" value={`$${data?.d_rew ? parseFloat(data.d_rew).toFixed(2) : "0.00"}`} />*/}
                  <Tile
                    neonClass="icon-green"
                    icon={<LuUsers />}
                    label="Growth Cycle"
                    value={`$${profile?.ror_rew ? parseFloat(profile.ror_rew).toFixed(2) : "0.00"}`}
                  />
                  <Tile
                    neonClass="icon-red"
                    icon={<LuTrophy />}
                    label="Snap Bonus"
                    value={`$${data?.level_rew ? parseFloat(data.level_rew).toFixed(2) : "0.00"}`}
                  />
                  <Tile
                    neonClass="icon-purple"
                    icon={<LuMedal />}
                    label="Salary Rank"
                    value={`$${profile?.rank_rew ? parseFloat(profile.rank_rew).toFixed(2) : "0.00"}`}
                  />
                  <Tile
                    neonClass="icon-cyan"
                    icon={<LuBriefcase />}
                    label="Team Business"
                    value={`$${data?.teambusiness ? parseFloat(data.teambusiness).toFixed(2) : "0.00"}`}
                  />
                  <Tile
                    neonClass="icon-orange"
                    icon={<LuTrendingUp />}
                    label="Direct Business"
                    value={`$${data?.direct_business ? parseFloat(data.direct_business).toFixed(2) : "0.00"}`}
                  />
                </div>
              </div>
              {/* ━━━ NETWORK STATISTICS ━━━ */}
              <div className="db-profile-card">
                <div className="db-sec-hdr">
                  <div className="db-sec-dot"></div>
                  <div className="db-sec-title">Network Statistics</div>
                </div>
                <div className="db-grid">
                  <Tile neonClass="icon-cyan" icon={<LuUserCheck />} label="Directs" value={data?.Directs || "0"} />
                  <Tile neonClass="icon-pink" icon={<LuGitMerge />} label="Open Level" value={profile?.open_level || "0"} />
                  <Tile neonClass="icon-green" icon={<LuUsers />} label="Total Team" value={data?.team || "0"} />
                  <Tile
                    neonClass="icon-blue"
                    icon={<LuLock />}
                    label="Total Stake"
                    value={`$${data?.totalstake ? parseFloat(data.totalstake).toFixed(2) : "0.00"}`}
                  />
                  <Tile
                    neonClass="icon-yellow"
                    icon={<LuWallet />}
                    label="Total Deposit"
                    value={`$${data?.totaldeposit ? parseFloat(data.totaldeposit).toFixed(2) : "0.00"}`}
                  />
                  <Tile
                    neonClass="icon-orange"
                    icon={<LuZap />}
                    label="3x Capping"
                    value={`$${data?.thrrexcap ? parseFloat(data.thrrexcap).toFixed(2) : "0.00"}`}
                  />
                  <Tile
                    neonClass="icon-red"
                    icon={<LuNetwork />}
                    label="1st Leg Business"
                    value={`$${data?.Strongleg1 ? parseFloat(data.Strongleg1).toFixed(2) : "0.00"}`}
                  />
                  <Tile
                    neonClass="icon-purple"
                    icon={<LuNetwork />}
                    label="2nd Leg Business"
                    value={`$${data?.Strongleg2 ? parseFloat(data.Strongleg2).toFixed(2) : "0.00"}`}
                  />
                  <Tile
                    neonClass="icon-cyan"
                    icon={<LuNetwork />}
                    label="Other Leg Business"
                    value={`$${data?.Otherleg_Team_business ? parseFloat(data.Otherleg_Team_business).toFixed(2) : "0.00"}`}
                  />
                  <Tile
                    neonClass="icon-blue"
                    icon={<LuClock />}
                    label="Pending Withdrawal"
                    value={`$${data?.Pending_withdraw_amt ? parseFloat(data.Pending_withdraw_amt).toFixed(2) : "0.00"}`}
                  />
                  <Tile
                    neonClass="icon-green"
                    icon={<LuArrowUpRight />}
                    label="Total Withdrawal"
                    value={`$${data?.Withdrawl ? parseFloat(data.Withdrawl).toFixed(2) : "0.00"}`}
                  />
                  <Tile
                    neonClass="icon-green"
                    icon={<LuArrowUpRight />}
                    label="Ecosystem Balance"
                    value={`$${data?.ecosystem_balance ? parseFloat(data.ecosystem_balance).toFixed(2) : "0.00"}`}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
